export default __webpack_public_path__ + "media/images/hot-ad804600d6e8aa72f737e0c16180e758.png";